import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'
import { useMeetingsPageTourContext } from 'features/meetings'
import { isMeetingsTourForceShownForTesting } from 'shared/constants/meetings_onboarding_tour'

import { primaryEmailFromContact } from '../hooks/primaryEmailFromContact'
import { useHasValidMeetingBriefCacheFromHost } from '../hooks/useHasValidMeetingBriefCacheFromHost'
import { useOpenMeetingPrepFromHost } from '../hooks/useOpenMeetingPrepFromHost'

export const GenerateMeetingPrep = ({ contact, meeting }) => {
  const meetingsPageTourContext = useMeetingsPageTourContext()
  const openMeetingPrep = useOpenMeetingPrepFromHost()
  const enforceUpgrade = useEnforceUpgrade('crm_meeting_prep', {
    skipPreface: true,
  })
  const hasCachedMeetingBrief = useHasValidMeetingBriefCacheFromHost(
    contact,
    meeting,
  )

  const handleGenerateMeetingPrep = (e) => {
    e.preventDefault()
    e.stopPropagation()
    enforceUpgrade(async () => {
      const didOpen = await openMeetingPrep(
        {
          id: contact.id,
          email: primaryEmailFromContact(contact),
          name: contact.fullName ?? contact.name,
        },
        meeting,
      )

      if (didOpen && isMeetingsTourForceShownForTesting()) {
        meetingsPageTourContext?.setMeetingBriefModalVisible(true)
      }
    })
  }

  return (
    <Button
      data-testid="generate-meeting-prep"
      data-tracking-action="generate_meeting_prep"
      data-tracking-location="meetings_page"
      size="small"
      onClick={handleGenerateMeetingPrep}
      decoration="ai"
      responsive={false}
    >
      {hasCachedMeetingBrief
        ? I18n.t('publisher.contacts.buttons.view_meeting_prep')
        : I18n.t('publisher.contacts.buttons.generate_meeting_prep')}
    </Button>
  )
}
